var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark--filled_1_",
    "data-name": "checkmark--filled (1)",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21041",
    "data-name": "Path 21041",
    d: "M10,2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "inner-path",
    d: "M11.857,17.052,9,14.195l.909-.909,1.948,1.948L16.091,11l.911.906Z",
    transform: "translate(-3 -3.857)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21044",
    "data-name": "Path 21044",
    d: "M3,7.789V9.049H4.261L7.979,5.331,6.718,4.071ZM8.953,4.356a.335.335,0,0,0,0-.474L8.167,3.1a.335.335,0,0,0-.474,0l-.615.615L8.338,4.972l.615-.615Z",
    transform: "translate(4.001 4.003)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkFilled);
export default __webpack_public_path__ + "static/media/checkmark--filled.2d8a2cf0c1c7481577d7635f552e1e2b.svg";
export { ForwardRef as ReactComponent };